import {Directive, ElementRef, Input, TemplateRef, ViewContainerRef} from '@angular/core'
import {UserSessionService} from '../../../services/user-session.service'
import {PERMISSION} from "@generated-backend-types";

@Directive({
    selector: '[appIfHasAllAndAnyPermissions]',
    standalone: true
})
export class IfHasAllAndAnyPermissionsDirective {
  @Input() set appIfHasAllAndAnyPermissions(permissions: {all: PERMISSION[], any: PERMISSION[]}) {
    if (
      permissions &&
      (
        permissions.all &&
        permissions.all.length > 0 &&
        this.authService.hasAllPermission(permissions.all)
      ) && (
        permissions.any &&
        permissions.any.length > 0 &&
        this.authService.hasAnyPermission(permissions.any)
      )
    ) {
      this.viewContainer.createEmbeddedView(this.templateRef)
    } else {
      this.viewContainer.clear()
    }
  }

  public constructor(
    private readonly element: ElementRef,
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly authService: UserSessionService
  ) {
  }
}
